<template>
  <div>
    <div id="billing-dataview" class="page-table scrollable">
      <div class="flex justify-space-between align-center mt-5 mb-10">
        <h2 class="mt-0 mb-0">
          <v-svg class="voxo-blue" sprite="list-numbers" />
          Invoices
        </h2>
        <el-button class="mb-0" @click="doExport"> Export </el-button>
      </div>
      <div class="billing-table card-base card-shadow--medium">
        <vxe-grid
          round
          class="user-stats-table"
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 6, oSize: 0 }"
          :loading="loading || tableLoading"
          :columns="[this.expandColumn, ...this.tableColumns]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { ExportToCsv } from "export-to-csv";
import {hostServer} from "@/feathers/feathers-client";

export default {
  name: "BillingRecords",
  props: {
    records: { required: true },
    loading: { required: true }
  },
  components: {},
  data() {
    return {
      exportCSV: false,
      search: "",
      total: 0,
      billingsChannel: null,
      tableData: [],
      allBillings: [],
      visibleActionsId: "",
      tableLoading: false,
      expandColumn: {
        type: "expand",
        width: "25px",
        showOverflow: true,
        slots: {
          content: ({ row }) => {
            return [
              <div class="billing-lineitem-table">
                <vxe-table
                  border="none"
                  show-overflow
                  highlight-hover-row
                  show-header={true}
                  height="250"
                  empty-text="No Davi"
                  scroll-y={{ enabled: true, gt: 10, oSize: 0 }}
                  data={row.data.lineItems}
                >
                  <vxe-table-column field="qty" title="QTY" width="75" />
                  <vxe-table-column
                    field="price"
                    title="Price"
                    min-width="100"
                  />
                  <vxe-table-column
                    field="product"
                    title="Product"
                    min-width="100"
                  />
                  <vxe-table-column
                    field="description"
                    title="Description"
                    min-width="100"
                  />
                </vxe-table>
              </div>,
            ];
          },
        },
      },
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-yellow" sprite="list-numbers" />
                </div>,
              ];
            },
          },
        },
        {
          field: "date",
          title: "Date",
          sortable: true,
          minWidth: 100,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              return [<span>{moment(row.date).format("YYYY-MM-DD")}</span>];
            },
          },
        },
/*        {
          field: "invoice",
          title: "Invoice #",
          sortable: true,
          minWidth: 100,
          showOverflow: true,
          sortType: 'number'
        },
        {
          field: "amount",
          title: "Total",
          sortable: true,
          minWidth: 100,
          showOverflow: false,
          sortType: 'number',
          slots: {
            default: ({row}) => {
              return [
                <span>{this.priceFormatter(row.amount)}</span>
              ]
            }
          }
        },
        {
          field: "amountAfterTax",
          title: "Total W/ Tax",
          sortable: true,
          minWidth: 150,
          showOverflow: false,
          sortType: 'number',
          slots: {
            default: ({row}) => {
              return [
                <span>{this.priceFormatter(row.amountAfterTax)}</span>
              ]
            }
          }
        },*/
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <el-tooltip placement="top" content="Download invoice">
                  <el-button
                    id={'edit-' + row.id}
                    icon="el-icon-download"
                    onClick={() => this.downloadInvoice(row.invoice)}
                    class="table-action-button icon-blue"
                  />
                </el-tooltip>
              ];
            },
          },
        },
      ],
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },

  watch: {
    records() {
      this.tableData = [...this.records];
      this.total = this.tableData.length;
    }
  },

  methods: {
    doExport() {
      this.$confirm(`Export data for ${this.total} Billing invoices?`, {
        type: "warning",
      })
        .then(() => {
          //export from browser
          let csvData = [];
          for (let i = 0; i < this.tableData.length; i++) {
            const exclude = ["id", "tenantId", "custom", "resellerData", "_XID", "billingId", "total", "hasCustom", "data", "qbId", "lineItems"];

            const keys = ['date', 'invoice', 'amount', 'amountAfterTax'];
            const dataKeys = ['name', 'extensions', 'faxes', 'sipTrunks', 'tollFree']

            const csvObject = {};
            //get column bi_data (json data with extensions, toll free minutes, etc)
            const billStats = this.tableData[i].data;

            for (let key of keys) {
              //go through bi_data to get json columns we want to include in the csv(extensions, toll free minutes, etc)
              for (let key of dataKeys) {
                if (!exclude.includes(key)) {
                  csvObject[key] = billStats[key] === null ? 0 : billStats[key];
                }
              }
              if (!exclude.includes(key)) {
                csvObject[key] = this.tableData[i][key] === null ? 0 : this.tableData[i][key];
              }
            }
            csvData.push(csvObject);

            //need to get lineitem data on the csv...

            //key map for line items
            //this fakes the root headers to the csv can build properly.
            const lineItemMap = {
              name: 'qty',
              extensions: 'price',
              faxes: 'product',
              sipTrunks: 'description'
            }

            const lineItems = billStats.lineItems;

              if(lineItems){

                //first push on the new headers for line items
                csvData.push({
                  name: 'Quantity',
                  extensions: 'Price',
                  faxes: 'Product',
                  sipTrunks: 'Description',
                  tollFree: '',
                  invoice: '',
                  date: '',
                  amount: '',
                  amountAfterTax: ''
                });

                for(let i = 0; i < lineItems.length; i++){
                  let csvObjectDist = {};
                  for (let key of dataKeys) {
                    csvObjectDist[key] = lineItems[i][lineItemMap[key]] === null ? 0 : lineItems[i][lineItemMap[key]];
                  }
                  csvObjectDist = {...csvObjectDist, tollFree: '', invoice: '', date: '', amount: '', amountAfterTax: ''}
                  if(!csvObjectDist.sipTrunks) csvObjectDist.sipTrunks = '';
                  csvData.push(csvObjectDist);
                }
              }

          }

          const options = {
            filename: "billing_summary",
            showLabels: true,
            headers: [
              "Name",
              "Extensions",
              "Faxes",
              "SIP Trunks",
              "Toll Free Minutes",
              "Date",
              "Invoice #",
              "Amount",
              "Total W/Tax",
            ],
          };

          const csvExporter = new ExportToCsv(options);
          csvExporter.generateCsv(csvData);
        })
        .catch(() => true);
    },

    //General Form and Table Operations
    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    downloadInvoice(invoiceNumber) {

      this.tableLoading = true;
      fetch(`${hostServer}/billing/${invoiceNumber}?tenantId=${this.selectedTenant.id}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.auth.accessToken}`
        }
      }).then(res =>
        res.blob()
      ).then(data => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(data);
        a.download = "invoice.pdf";
        a.click();
        this.tableLoading = false;
      }).catch( () => {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: 'Failed to download invoice.'
        })
        this.tableLoading = false;
      });

    },

    tablePriceFormatter(data) {
      return this.priceFormatter(data.cellValue);
    },

    priceFormatter(val) {
      return `$${(new Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(val))}`
    }
  },

};
</script>

<style lang="scss" scoped>

.billing-table {
  height: 450px;
}

</style>
